import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/AuthShell";

export default function Register() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/api/auth/register", {
        email, password, name: name || undefined,
      });
      setUser(data.user);
      toast.success(`Welcome to Territoria, ${data.user.name}.`);
      nav("/play");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell
      title="Forge a character"
      subtitle="Your name will be written into the annals."
      footer={
        <>
          Already an adventurer?{" "}
          <Link to="/login" className="text-amber-500 hover:text-amber-400 underline" data-testid="link-login">
            Sign in
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-4 font-body" data-testid="register-form">
        <label className="block">
          <span className="text-stone-400 text-sm mb-1 block">Adventurer name</span>
          <input
            type="text"
            maxLength={20}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Leave blank to use email prefix"
            className="w-full bg-stone-950 border border-stone-700 rounded px-3 py-2 focus:border-amber-600 outline-none"
            data-testid="register-name"
          />
        </label>
        <label className="block">
          <span className="text-stone-400 text-sm mb-1 block">Email</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-stone-950 border border-stone-700 rounded px-3 py-2 focus:border-amber-600 outline-none"
            data-testid="register-email"
          />
        </label>
        <label className="block">
          <span className="text-stone-400 text-sm mb-1 block">Password (6+ chars)</span>
          <input
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-stone-950 border border-stone-700 rounded px-3 py-2 focus:border-amber-600 outline-none"
            data-testid="register-password"
          />
        </label>
        <button
          type="submit"
          disabled={submitting}
          className="btn-gold w-full py-2.5 disabled:opacity-60"
          data-testid="register-submit"
        >
          {submitting ? "Inscribing the ledger…" : "Begin your saga"}
        </button>
      </form>
    </AuthShell>
  );
}
